import React, { useRef, useState } from "react";
import { Button, IconButton } from "@sscs/ui";
import { CheckIcon, CopyIcon } from "@sscs/ui/icons";
import { REPORT_PAGES_ROUTES, REPORT_QUERY_PARAMS } from "../../constants";
import { LinkToReportTab } from "../common";
import styles from "./fileBrowser.module.scss";
const ROOT_CRUMB_LABEL = "<Root>";
const CopyFullPath = ({ fullPath }) => {
    const [copied, setCopied] = useState(false);
    const resetTimeout = useRef(undefined);
    const onCopy = async () => {
        await navigator.clipboard.writeText(fullPath);
        setCopied(true);
        clearTimeout(resetTimeout.current);
        resetTimeout.current = setTimeout(() => setCopied(false), 1500);
    };
    return (React.createElement(IconButton, { id: "copy-full-path", size: "small", tooltipTitle: `Copy full path (${fullPath.length} characters)`, onClick: onCopy }, copied ? React.createElement(CheckIcon, null) : React.createElement(CopyIcon, null)));
};
const buildCrumbSearch = (searchParamEntries, crumbPath) => new URLSearchParams([
    ...searchParamEntries,
    [REPORT_QUERY_PARAMS.path, crumbPath],
]).toString();
const LocationLedger = ({ path, searchParamEntries, fileName, isExplorerVisible, onToggleExplorer, }) => {
    const pathSegments = path.split("/").filter((segment) => segment !== "");
    const rootIsLink = pathSegments.length > 0 || fileName !== null;
    const fullPath = `/${[...pathSegments, fileName]
        .filter((segment) => Boolean(segment))
        .join("/")}`;
    const crumbs = [
        rootIsLink ? (React.createElement(LinkToReportTab, { key: "root", id: "location-root", to: {
                pathname: REPORT_PAGES_ROUTES.FILE_BROWSER_ROUTE,
                search: buildCrumbSearch(searchParamEntries, ""),
            }, color: "link", className: styles["location-crumb"] }, ROOT_CRUMB_LABEL)) : (React.createElement("span", { key: "root", className: styles["location-crumb"] }, ROOT_CRUMB_LABEL)),
    ];
    pathSegments.forEach((segment, index) => {
        const isCurrentFolder = index === pathSegments.length - 1 && fileName === null;
        crumbs.push(isCurrentFolder ? (React.createElement("span", { key: index, className: styles["location-crumb"] }, segment)) : (React.createElement(LinkToReportTab, { key: index, id: `location-${segment}`, to: {
                pathname: REPORT_PAGES_ROUTES.FILE_BROWSER_ROUTE,
                search: buildCrumbSearch(searchParamEntries, `${pathSegments.slice(0, index + 1).join("/")}/`),
            }, color: "link", className: styles["location-crumb"] }, segment)));
    });
    if (fileName !== null) {
        crumbs.push(React.createElement("span", { key: "file", className: `${styles["location-crumb"]} ${styles["location-file"]}` }, fileName));
    }
    return (React.createElement("div", { className: styles["location-ledger"] },
        React.createElement("div", { className: styles["location-crumbs"] },
            crumbs.map((crumb, index) => (React.createElement(React.Fragment, { key: index },
                index > 0 && (React.createElement("span", { className: styles["location-separator"], "aria-hidden": "true" }, "/")),
                crumb))),
            React.createElement(CopyFullPath, { fullPath: fullPath })),
        React.createElement(Button, { isInline: true, color: "secondary", onClick: onToggleExplorer, className: styles["explorer-toggle"] }, isExplorerVisible ? "Hide file explorer" : "Show file explorer")));
};
export default LocationLedger;
//# sourceMappingURL=LocationLedger.js.map